<div class="wrapper client-workspace">
  <div class="sidebar navbar" data-color="white" data-background-color="innporting" data-image="./assets/img/sidebar-company.jpg">
    <app-sidebar></app-sidebar>

  </div>
  <div class="main-panel">
    <app-navbar></app-navbar>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </div>
</div>
<app-company-on-boarding></app-company-on-boarding>
